// extracted by mini-css-extract-plugin
export default {"container":"side_container__ax5PN","tituloText":"side_tituloText__qe3-+"};